import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import infoicon from "../../Components/assets/Images/infoicon.svg";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

interface props {
  message: any;
}

export default function BankSnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message.Bank.length > 1) {
      setOpen(true);
      setTransition(() => TransitionUp);
    }
    if (message.Bank.length === 0) {
      setOpen(false);
      setTransition(() => TransitionUp);
    }
  }, [message]);

  //console.log(message)
  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={transition}
        sx={{
          position: "absolute",
          top: { xs: "80px", sm: "20px" },
          right:{xs:"16px !important",sm:"0%"},
          transform: "unset",
          maxWidth: "1500px",
          width: "100%",
          zIndex: 99,
          left:"-10px"
        }}
      >
        <div
          style={{
            borderRadius: "4px ",
            overflow: "hidden",
            border: "1px solid var(--ds-outline)",
            background:"var(--ds-bg)"
          }}
        >
          <div >
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: "max-content",
                minHeight: "24px",
                gap: "3px",
                height: "max-content",
                fontSize: "12px",
                borderRadius: "0",
                display: "flex !important",
                alignItems: "center",
                textAlign: "left",
                background: "none",
                fontFamily: "inherit",
                // padding:"0px"
                padding: "6px 7px",

                "& .MuiAlert-message": {
                  padding: "0px !important",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  padding: "0px",
                }}
              >
                <img src={infoicon} alt="" />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "14px",
                    color: "var(--ds-text-primary)",
                  }}
                >
                  {message.Bank}, {message.Address}{" "}
                </p>
                <div
                  onClick={() => {
                    setOpen(false);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <CloseIcon
                    style={{
                      color: "var(--ds-text-secondary)",
                      marginBottom: "-2px",
                    }}
                  />
                </div>
              </div>
            </Alert>
          </div>
        </div>
      </Snackbar>
    </div>
  );
}
